/**
 * @packageDocumentation
 * @module HackerAPI.Claim.Collaborator
 */
import { __extends } from "tslib";
import Base from "../../base/base";
import HackerAPIFetch from "../../hackerapi-fetch/hackerapi-fetch";
import { parseDate } from "../../utils/utils";
/**
 * A data container for claim collaborators with static methods for interfacing with hackerapi.com
 * @class
 * @extends { HackerAPI.Base }
 */
var Collaborator = /** @class */ (function (_super) {
    __extends(Collaborator, _super);
    /**
     * Creates a new Collaborator instance
     * @constructor
     * @param collaborator
     */
    function Collaborator(_a) {
        var id = _a.id, name = _a.name, user = _a.user, created_at = _a.created_at, createdAt = _a.createdAt, linkedin = _a.linkedin, program = _a.program, gender = _a.gender, skills = _a.skills, school = _a.school, graduatingYear = _a.graduatingYear, email = _a.email, portfolio = _a.portfolio, github = _a.github;
        var _b, _c;
        var _this = _super.call(this, {
            id: function (k, v) { return ["user_id", v]; },
            name: Base.doNotSendHandler,
            linkedin: Base.doNotSendHandler,
            program: Base.doNotSendHandler,
            gender: Base.doNotSendHandler,
            skills: Base.doNotSendHandler,
            school: Base.doNotSendHandler,
            graduatingYear: Base.doNotSendHandler,
            email: Base.doNotSendHandler,
            portfolio: Base.doNotSendHandler,
            github: Base.doNotSendHandler,
            createdAt: Base.doNotSendHandler
        }) || this;
        /**
         * The ID of the user that is collaborating on the claim
         * @type { number }
         */
        _this.id = id;
        /**
         * The name of the collaborator
         * @type { string }
         */
        _this.name = name;
        /**
         * The linkedin link of the user
         * @type { string }
         */
        _this.linkedin = linkedin;
        /**
         * The program of the user
         * @type { string }
         */
        _this.program = program;
        /**
         * The gender of the user
         * @type { string }
         */
        _this.gender = ((_b = user) === null || _b === void 0 ? void 0 : _b.gender) || gender;
        /**
         * Any skills the user may possess
         * @type { string[] }
         */
        _this.skills = skills;
        /**
         * The name of the school the user is attending
         * @type { string }
         */
        _this.school = school;
        /**
         * The year the user is graduating
         * @type { number }
         */
        _this.graduatingYear = graduatingYear;
        /**
         * The email of the user
         * @type { string }
         */
        _this.email = ((_c = user) === null || _c === void 0 ? void 0 : _c.email) || email;
        /**
         * The portfolio link(s) of the user
         * @type { string }
         */
        _this.portfolio = portfolio;
        /**
         * The github link of the user
         * @type { string }
         */
        _this.github = github;
        /**
         * When the collaborator was added to the claim
         * @type { Date }
         */
        _this.createdAt = parseDate(created_at || createdAt);
        return _this;
    }
    /**
     * Fetches all the collaborators for a claim
     * @param claim
     * @param claim.id
     * @param [auth]
     * @param [auth.token]
     * @returns
     */
    Collaborator.fetchAll = function (_a, token) {
        var id = _a.id;
        return HackerAPIFetch({
            path: "/v2/claims/" + id + "/collaborators",
            method: "GET",
            token: token
        }).then(function (data) {
            return data.map(function (datum) { return new Collaborator(datum); });
        });
    };
    /**
     * Adds a new collaborator for a claim
     * @param claim
     * @param claim.id
     * @param collaborator
     * @param [auth]
     * @param [auth.token]
     * @returns
     */
    Collaborator.add = function (_a, token) {
        var id = _a.id;
        return HackerAPIFetch({
            path: "/v2/claims/" + id + "/collaborators",
            method: "POST",
            token: token
        }).then(function (data) { return new Collaborator(data); });
    };
    /**
     * Deletes a collaborator for a claim
     * @param claim
     * @param claim.id
     * @param collaborator
     * @param collaborator.userId
     * @param [auth]
     * @param [auth.token]
     * @returns
     */
    Collaborator.delete = function (_a, collaborator, token) {
        var id = _a.id;
        return HackerAPIFetch({
            path: "/v2/claims/" + id + "/collaborators",
            method: "DELETE",
            token: token,
            body: collaborator.toHackerAPIFormat()
        });
    };
    return Collaborator;
}(Base));
export default Collaborator;
//# sourceMappingURL=collaborator.js.map